import { Platform } from 'react-native';

export default Platform.select({
  ios: 21500,
  default: 12,
});
